// @flow

import { useTranslator } from '@gandi/translate';

import { UntransferableReason } from '../../DomainTransfer/components/UntransferableReason';
import type { UnavailableDomainProduct } from '../types';

import { ResultRow } from './ResultRow';

type Props = {
  result: UnavailableDomainProduct,
};

export function UnavailableResult({ result }: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <ResultRow
      iconName="unavailable"
      statusText={__('Unavailable')}
      fqdn={result.fqdn}
      pricingBlock={
        result.msg && (
          <UntransferableReason fqdn={result.fqdn} reason={result.msg} />
        )
      }
    />
  );
}
